import React from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { PageHeader } from "../../components/UI";
import SimpleActionFormV2 from "../../components/GreenMiles/CreateAction/SimpleActionForm";
import { Sidebar } from "../../components/Sidebar";

function EditActionPage() {
  const { hotelId, actionId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo");

  const getReturnUrl = () => {
    if (returnTo === "actions") {
      return `/hotels/${hotelId}/greenmiles/actions`;
    }
    return `/hotels/${hotelId}/greenmiles`;
  };

  const handleSuccess = () => {
    navigate(getReturnUrl(), {
      state: {
        message: "Action modifiée avec succès !",
        type: "success",
      },
    });
  };

  const handleCancel = () => {
    navigate(getReturnUrl());
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <PageHeader title={`Modifier l'action`} onGoBack={handleCancel} />
        <div className="p-6">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6">
            <SimpleActionFormV2 hotelId={hotelId} actionId={actionId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditActionPage;
